import { useTranslation } from 'react-i18next';
import { AadeBookInvoiceType } from '../../../../interfaces/myData.interface';

interface Props {
  doc: AadeBookInvoiceType;
}

const SummaryRow = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="flex-space-between-center-row-nowrap margin-b-4">
    <div className="boldText4">{label}</div>
    <div className="normalText4">{value}</div>
  </div>
);

const fmt = (amount: number, currency?: string) =>
  currency ? `${amount} ${currency}` : String(amount);

export const GsisDocSummary = ({ doc }: Props) => {
  const { t } = useTranslation();
  const s = doc?.invoiceSummary;
  const currency = doc?.invoiceHeader?.currency;
  if (!s) return null;

  return (
    <div className="simpleBorder p-12 width-100">
      <div className="flex-space-between-center-row-nowrap margin-b-8">
        <div className="boldText5">{t('DELIVERY.INVOICE_TOTALS')}</div>
        {currency && <div className="normalText4">{currency}</div>}
      </div>

      <SummaryRow label={t('DELIVERY.TOTAL_NET_VALUE')} value={fmt(s.totalNetValue, currency)} />
      <SummaryRow label={t('DELIVERY.TOTAL_VAT_AMOUNT')} value={fmt(s.totalVatAmount, currency)} />
      {s.totalWithheldAmount > 0 && (
        <SummaryRow label={t('DELIVERY.TOTAL_WITHHELD_AMOUNT')} value={fmt(s.totalWithheldAmount, currency)} />
      )}
      {s.totalFeesAmount > 0 && (
        <SummaryRow label={t('DELIVERY.TOTAL_FEES_AMOUNT')} value={fmt(s.totalFeesAmount, currency)} />
      )}
      {s.totalStampDutyAmount > 0 && (
        <SummaryRow label={t('DELIVERY.TOTAL_STAMP_DUTY_AMOUNT')} value={fmt(s.totalStampDutyAmount, currency)} />
      )}
      {s.totalOtherTaxesAmount > 0 && (
        <SummaryRow label={t('DELIVERY.TOTAL_OTHER_TAXES_AMOUNT')} value={fmt(s.totalOtherTaxesAmount, currency)} />
      )}
      {s.totalDeductionsAmount > 0 && (
        <SummaryRow label={t('DELIVERY.TOTAL_DEDUCTIONS_AMOUNT')} value={fmt(s.totalDeductionsAmount, currency)} />
      )}

      <div style={{ borderTop: '1px solid var(--ion-border-color, #333)', marginTop: 6, paddingTop: 6 }}>
        <SummaryRow
          label={t('DELIVERY.TOTAL_GROSS_VALUE')}
          value={<strong>{fmt(s.totalGrossValue, currency)}</strong>}
        />
      </div>
    </div>
  );
};
